import React, { ErrorInfo } from 'react';
import { useSiteContext } from '../../context/site-content.context';

export type ImageDisplayComponent = (
    props: ImageDisplayProps
) => React.ReactElement<any, any> | null;

export interface ImageDisplayProps {
    alt: string;
    src: string;
    height?: string;
    width?: string;
    imgClassName?: string;
    onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

// this has to be it's own element for some suspense reason that I don't fully understand
// const ImageInner = ({
//     src,
//     imgClassName,
//     alt,
//     width,
//     height,
// }: ImageDisplayProps): React.ReactElement<any, any> | null => {
//     const { src: innerSrc } = useImage({ srcList: src });

//     return <img className={imgClassName} alt={alt} src={innerSrc} width={width} height={height} />;
// };

export const ImageDisplay: ImageDisplayComponent = (
    props: ImageDisplayProps
): React.ReactElement<any, any> | null => {
    const {
        config: { ImageDisplay },
    } = useSiteContext();

    if (ImageDisplay) {
        return <ImageDisplay {...props} />;
    }

    const { src, imgClassName, alt, width, height } = props;

    return <img className={imgClassName} alt={alt} src={src} width={width} height={height} />;

    // const onErrorInner = (error: Error, errorInfo: ErrorInfo) => {
    //     if (props.onError) {
    //         props.onError(error, errorInfo);
    //     }
    // };

    // return (
    //     // the key will force the underlying components to rerender on change
    //     <ImageErrorBoundry {...props} onError={onErrorInner} key={props.src}>
    //         <Suspense fallback={<FallbackImage {...props} />}>
    //             <ImageInner {...props} />
    //         </Suspense>
    //     </ImageErrorBoundry>
    // );
};
